// extracted by mini-css-extract-plugin
module.exports = {"inviteModal":"inviteModal_inviteModal__2Xa1E","permissionsContainer":"inviteModal_permissionsContainer__2lvqD"};